import { ActionIcon, Divider, Group, Menu, useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { IconDots, IconDownload, IconUserCheck } from '@tabler/icons-react';
import { FlagToggle, StarRating } from 'core/components/index';
import { logger } from 'utils/logger';
import { CaptureEventType } from './CaptureThumb';
import classes from './CaptureToobar.module.scss';
import { pluralize } from 'utils/helper';


const CaptureToolbar = ({selectedItems, settings, settingsChange, size='md',onCaptureChange, rating, status}) =>{
    const theme = useMantineTheme();
    const { colorScheme } = useMantineColorScheme();

    const onRatingChange = (val) => {
      onCaptureChange(CaptureEventType.RATING_CHANGE,{data:val},selectedItems);
    }

    const onFlagChange = (val) => {
      onCaptureChange(CaptureEventType.STATUS_CHANGE,{data:val},selectedItems);
    }

    const downloadHandler = (type) => {
      logger.log('CAPTURE DOWNLOAD')
      onCaptureChange(CaptureEventType.DOWNLOAD,{data:null,type:type},selectedItems);
    }

    const onTagTalent = (val) => {
      onCaptureChange(CaptureEventType.TAG_TALENT,{data:val},selectedItems);
    }

    const batchUpdateApprovalNotes = (type) => {
      logger.log('CAPTURE DOWNLOAD')
      onCaptureChange(CaptureEventType.SHOW_BATCH_NOTES_EDITOR,{data:null,type:type},selectedItems);
    }

    return (  
        <Group style={{width:'auto'}} className={classes.container} gap='xs' wrap='nowrap'>
            
          <StarRating size={size} rating={rating} onChange={onRatingChange} />
          {/* <Rating value={rating} onClick={(e) => e.stopPropagation()} onChange={onRatingChange} size={'xs'} /> */}
          {/* <StarRatingExtended rating={rating} onClick={(e) => e.stopPropagation()} onChange={onRatingChange} size={'xs'} /> */}
          <Divider orientation="vertical" />
          <FlagToggle size={size} status={status} onChange={onFlagChange} />

          <Menu shadow="md" width={200}>
            <Menu.Target>
              <ActionIcon variant="transparent"><IconDots size={size === 'sm'?12:14} /></ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item onClick={(e) => {downloadHandler('loURL')}} icon={<IconDownload size={14} />}>Download {pluralize('Image', selectedItems?.length)}</Menu.Item>
              {selectedItems?.length ? <Menu.Item onClick={(e) => {batchUpdateApprovalNotes()}} icon={<IconDownload size={14} />}>Batch Update Approval Notes</Menu.Item> : null}
              {/* <Menu.Item onClick={(e) => {downloadHandler('eipURL')}} icon={<IconDownload size={14} />}>Download EIP</Menu.Item> */}
              {/* <Menu.Item onClick={(e) => {onTagTalent('tag')}} icon={<IconUserCheck size={14} />}>Tag Talent</Menu.Item> */}
                
              {/* <Menu.Item icon={<IconTransferIn size={14} />}>Assign to session</Menu.Item>        */}
            </Menu.Dropdown>
          </Menu>

        </Group>
    )
}

export default CaptureToolbar;


